import { GlobalSearchScopeIdentifier, IntegrationFlowGlobalSearchResultItem } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { TimeZone } from "client/DateAndTime/timezones";
import { ReactElement } from "react";
import { IntegrationFlowListItem } from "../../../Items/IntegrationFlowListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { generateTrackingId } from "client/Misc/utils";
import { useIntegrationFlowNavigationHandler } from "../../../Navigation/useIntegrationFlowNavigationHandler";

export type IntegrationFlowItemViewProps = {
	item: IntegrationFlowGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	timezone: TimeZone;
	tabIndex: number;
};

export const IntegrationFlowItemView = (props: IntegrationFlowItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		timezone,
		tabIndex
	} = props;

	const {
		title,
		dateTime,
		subTitle1,
		subTitle2,
		hitHighlights,
		color,
		icon,
		link
	} = item;

	const openHandler: () => void = useIntegrationFlowNavigationHandler({
		link,
		searchResult: item,
		itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("integration-flow-item", `|${itemIndex}`)}
			onClick={openHandler}
		>
			<IntegrationFlowListItem
				title={title}
				dateTime={dateTime}
				subTitle1={subTitle1}
				subTitle2={subTitle2}
				color={color}
				icon={icon}
				timezone={timezone}
				hitHighlights={hitHighlights}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
IntegrationFlowItemView.displayName = "IntegrationFlowItemView";
